export default __webpack_public_path__ + "static/media/convocatoriaAgenda.fb4335b0.jpeg";